import React, { Fragment } from 'react';
import { OrderCreated } from './OrderCreated';
import { ShippingMethod } from './ShippingMethod';

export const TrackingInformation = ({ tracking }) => {
    return (
        <Fragment>
        {
            tracking && 
            <section className="information">
                <div className="information__boxes">
                    <OrderCreated date={tracking.saleDatetime} />
                    <ShippingMethod shipping_method={tracking.shippingType} />
                </div>
                <hr />
            </section>
        }
        </Fragment>
    )
}